module.exports = __webpack_public_path__ + "img/happy-safer.65f79fbc.png";